import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const NestedItems = ({ items, type, isLastGroup = true }) =>
  items.map((item, idx) => {
    const itemQty = item?.quantity ?? item?.sales_count ?? 1;
    const isLast = isLastGroup && idx === items.length - 1;
    const dividerClass = isLast ? '' : 'border-0 border-b border-dashed border-neutral-200';
    return (
      <div key={`${item?.name}-${idx}`} className={cn('pb-0.5 pl-3', dividerClass)}>
        <Typography variant="p" size="xs" weight="medium" color="neutral-600">
          {item?.name}
          {type ? ` · ${type}` : ''}
          {itemQty > 1 ? ` ×${itemQty}` : ''}
        </Typography>
      </div>
    );
  });

export default NestedItems;
